module.exports = __webpack_public_path__ + "img/symbol_2.5bca0060.png";